import { Switch, styled } from "@mui/material";

interface SwitchProps {
  withText?: boolean;
}

export const StyledToggle = styled(Switch, {
  shouldForwardProp: (prop) => prop !== "withText",
})<SwitchProps>`
  padding: 0;
  width: ${(props) => (props.withText ? "3.357rem" : "2.857rem")};
  height: auto;

  && .MuiButtonBase-root {
    padding: 0;
  }

  :hover {
    && .MuiSwitch-track {
      background-color: ${(props) => props.theme.wsc.palette.neutral[400]};
    }
  }

  :hover {
    && .Mui-checked + .MuiSwitch-track {
      background-color: ${(props) => props.theme.wsc.palette.primary[100]};
    }
  }

  && .Mui-checked + .MuiSwitch-track {
    background-color: ${(props) => props.theme.wsc.palette.primary[300]};
    opacity: 1;
    ${(props) =>
      props.withText &&
      `
      :before {
        content: 'ON';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 1.214rem;
        height: 1rem;
        font-size: ${props.theme.wsc.typography.label.fontSize};
        font-weight: ${props.theme.wsc.typography.label.fontWeight};
        color: ${props.theme.wsc.palette.primary.contrastText};
        left: ${props.theme.wsc.spacing[1]};
      }
    `}
  }

  .MuiSwitch-track {
    opacity: 1;
    ${(props) =>
      props.withText &&
      `
          :before {
            content: 'OFF';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 1.214rem;
            height: 1rem;
            font-size: ${props.theme.wsc.typography.label.fontSize};
            font-weight: ${props.theme.wsc.typography.label.fontWeight};
            color: #FFFFFFEB;
            right: ${props.theme.wsc.spacing[1]};
          }
      `}
  }

  && .MuiSwitch-thumb {
    height: 1.143rem;
    width: 1.143rem;
    bottom: 0;
    margin-top: 0.143rem;
    margin-left: 0.143rem;
  }

  && .MuiSwitch-track {
    background-color: ${({ theme }) => theme.wsc.palette.neutral[600]};
    height: 1.429rem;
    width: ${(props) => (props.withText ? "3.357rem" : "2.857rem")};
    border-radius: ${(props) => props.theme.wsc.radius.l};
  }

  /* ===== checked ===== */
  && .Mui-checked {
    .MuiSwitch-thumb {
      background-color: ${({ theme }) =>
        theme.wsc.palette.primary.contrastText};
      margin-left: ${(props) => (props.withText ? "0.657rem" : "0.157rem")};
    }
  }

  /* ===== disabled ===== */
  && .Mui-disabled + .MuiSwitch-track {
    background-color: ${({ theme }) => theme.wsc.palette.neutral[500]};
    opacity: 1;
    ${(props) =>
      props.withText &&
      `
        :before {
          color: #FFFFFF66;
        }
      `}
  }

  && .Mui-disabled {
    .MuiSwitch-thumb {
      background-color: ${({ theme }) => theme.wsc.palette.neutral[300]};
    }
  }

  && .Mui-disabled.Mui-checked {
    .MuiSwitch-thumb {
      background-color: ${({ theme }) => theme.wsc.palette.neutral[300]};
    }
  }

  :hover {
    && .Mui-disabled.Mui-checked + .MuiSwitch-track {
      background-color: ${({ theme }) => theme.wsc.palette.primary[700]};
    }

    && .Mui-disabled + .MuiSwitch-track {
      background-color: ${({ theme }) => theme.wsc.palette.neutral[500]};
    }
  }

  && .Mui-disabled.Mui-checked + .MuiSwitch-track {
    background-color: ${({ theme }) => theme.wsc.palette.primary[700]};
    opacity: 1;
    ${(props) =>
      props.withText &&
      `
        :before {
          content: 'ON';
          color: ${props.theme.wsc.palette.neutral[300]};
        }
      `}
  }
`;
